module.exports = __webpack_public_path__ + "img/powered-by-light.c4d0454a.svg";